import { Search } from 'lucide-react';
import {
   ADD_OUT_ADJUSTMENT,
   ADD_VOUCHER,
   ADJUSTMENT_VOUCHER_BALANCE,
   ADJUSTMENT_VOUCHER_DETAILS,
   DELETE_VOUCHER,
   GET_ADJUSTED_VOUCHER,
   GET_BANK_VOUCHER,
   GET_LAST_VOUCHER_DAYBOOK,
   GET_ONE_VOUCHER,
   GET_VOUCHER,
   LAST_VOUCHER_DETAILS,
   PENDING_VOUCHER_DETAILS,
   SET_PENDING_VOUCHER,
   UPDATE_VOUCHER,
   UPDATE_VOUCHER_CLEARING_DATE,
   VOUCHER_PREV_NEXT,
   GET_GLOBAL_SEARCH,
} from '../types';

const initialState = {
   Search: [],
};

const reducer = (state = initialState, action) => {
   const { type, payload, totalCount } = action;

   switch (type) {
      case GET_GLOBAL_SEARCH:
         return { ...state, Search: payload.data };

      default:
         return state;
   }
};

export default reducer;
